const EomExportFilterTypeEnum = {
  All: 'All',
  Evaluator: 'Evaluator',
  TpEvaluator: 'TpEvaluator',
  ClientInvoice: 'ClientInvoice',
  TpClientInvoice: 'TpClientInvoice',
  Client: 'Client',
};

export default EomExportFilterTypeEnum;
